
import { store } from '@/assets/scripts/store'

export default {
  name: 'MediaThumb',

  props: {
    label: { type: String, default: null },
    poster: { type: String, default: null },
    media: { type: Object, default: () => {} },
    enabled: { type: Boolean, default: true },
    cover: { type: Boolean, default: true },
  },

  data() {
    return {
      playerActive: false,
    }
  },

  computed: {
    screenLarge() {
      return store.screenLarge
    },
    touchDevice() {
      return store.touchDevice
    },
  },

  watch: {
    enabled(value) {
      if (!value) {
        this.playerActive = false
      }
    },

    playerActive(value) {
      value ? this.$refs.video.play() : this.$refs.video.pause()
    }
  },
}
